import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

// Date "2026-06-23" -> "23/6" (lisible, sans année qui surcharge).
const fmtDay = (d) => {
  const p = String(d || '').split('-');
  return p.length === 3 ? `${parseInt(p[2], 10)}/${parseInt(p[1], 10)}` : (d || '');
};

// Graphe d'aire NATUREL (courbe lissée + dégradé + axe dates + échelle + survol).
// data = [{ date: 'YYYY-MM-DD', count: n }]. Réutilisé par le dashboard et les tracking links.
export default function ConvAreaChart({ data, height = 210, color = '#73a6ff', unit = 'nouvelles convs', emptyText = 'Aucune donnée sur cette période.' }) {
  const pts = (data || []).map((d) => ({ date: fmtDay(d.date), count: Number(d.count) || 0 }));
  if (!pts.length) return <div className="text-sm text-slate-500 py-10 text-center">{emptyText}</div>;
  const allZero = pts.every((p) => p.count === 0);
  if (allZero) return <div className="text-sm text-slate-500 py-10 text-center">{emptyText}</div>;
  const gid = 'cg_' + color.replace('#', '');
  return (
    <div style={{ width: '100%', height }} data-testid="conv-area-chart">
      <ResponsiveContainer>
        <AreaChart data={pts} margin={{ top: 12, right: 10, left: -16, bottom: 0 }}>
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.35} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="rgba(255,255,255,0.05)" vertical={false} />
          <XAxis dataKey="date" tick={{ fill: '#8b8f98', fontSize: 11 }} tickLine={false} axisLine={false} minTickGap={26} interval="preserveStartEnd" />
          <YAxis tick={{ fill: '#8b8f98', fontSize: 11 }} tickLine={false} axisLine={false} allowDecimals={false} width={32} />
          <Tooltip
            cursor={{ stroke: 'rgba(255,255,255,0.15)' }}
            contentStyle={{ background: '#0B0B0E', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 10, fontSize: 12, padding: '6px 10px' }}
            labelStyle={{ color: '#e8eaed', marginBottom: 2 }}
            itemStyle={{ color }}
            formatter={(v) => [`${v} ${unit}`, '']}
          />
          <Area type="monotone" dataKey="count" stroke={color} strokeWidth={2.4} fill={`url(#${gid})`} dot={{ r: 2.4, fill: color, strokeWidth: 0 }} activeDot={{ r: 4.5 }} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
